<template>
  <div class="listItem">
    <div class="content">
      <div class="coupon_item">
        <!-- 优惠券 -->
        <div class="left" v-if="isRewardType(data, 'coupon')">
          <!-- 满减券 -->
          <div
            class="couponHead"
            v-if="
              couponType === 'DISCOUNT_NO_CONDITION' ||
                couponType === 'DISCOUNT_WITH_CONDITION'
            "
          >
            <div class="value">
              <span class="unit">&yen;</span
              ><span class="integerPart">{{
                Math.floor(data.discountAmount / 100)
              }}</span
              ><span class="floatPart">{{
                data.discountAmount % 100 !== 0
                  ? `.${data.discountAmount % 100}`
                  : ''
              }}</span>
            </div>
            <div class="condition">{{ couponDescText(data) }}</div>
          </div>
          <!-- 折扣券 -->
          <div class="couponHead" v-if="couponType === 'DISCOUNT_BY_RATE'">
            <div class="value">
              <span class="integerPart">{{
                Math.floor(data.discountRate / 10)
              }}</span
              ><span class="floatPart"
                >.{{
                  data.discountRate % 10 !== 0 ? data.discountRate % 10 : 0
                }}</span
              ><span class="suffix">折</span>
            </div>
            <div class="condition">{{ couponDescText(data) }}</div>
          </div>
        </div>
        <!-- 现金红包 -->
        <div class="left" v-else-if="isRewardType(data, 'cash')">
          <div class="cashHead">
            <div class="value">
              <span class="unit">&yen;</span
              ><span class="integerPart">{{
                Math.floor(data.amount / 100)
              }}</span
              ><span class="floatPart">.{{ data.amount % 100 }}</span>
            </div>
          </div>
        </div>
        <!-- 加油券 -->
        <div class="left" v-else-if="isRewardType(data, 'oil')">
          <div class="oilHead">
            <div class="name">
              加油券
            </div>
            <div class="value">10元</div>
            <div class="condition">无门槛</div>
          </div>
        </div>
        <div class="right">
          <div class="right_content">
            <div class="name">
              <div class="type">
                {{ data | tagText }}
              </div>
              <div class="text">{{ data.title }}</div>
            </div>
            <div class="time">
              {{ data.startTime | timeFormat }}-{{ data.endTime | timeFormat }}
            </div>
            <div
              v-if="isShowRuleBtn && isRewardType(data, 'coupon')"
              class="detail"
              @click="handleClickRule"
            >
              使用规则
              <span :class="['ruleArrow', { reverse: isShowRule }]"></span>
            </div>
          </div>
          <div
            v-if="isRewardType(data, 'coupon') && isShowToUseButton"
            class="right_btn"
            @click="useTicket(data)"
          >
            去使用
          </div>
          <div
            v-if="isRewardType(data, 'cash') && isShowToUseButton"
            class="right_btn"
            @click="handleClickWithdraw"
          >
            去提现
          </div>
        </div>
      </div>
      <div class="rulePanel" v-if="isShowRule && detail">
        <div v-if="detail.businessType && Number(detail.businessType) !== 8">
          适用业务：{{ getBusiness(detail.businessType) }}业务
        </div>
        <div v-if="detail.purposeType">
          适用用途：{{ detail.purposeType | filterPurpose }}
        </div>
        <div v-if="detail.numLimit">
          号码限制：{{
            Number(detail.numLimit) === 1 ? '登录号码需与联系人一致' : '不限制'
          }}
        </div>
        <div v-if="detail.clientType && Number(detail.clientType) !== 0">
          适用端口(渠道)：{{ detail.clientType | filterClient }}
        </div>
        <div v-if="detail.orderVehicleType">
          可用车型：{{
            Number(detail.orderVehicleType) === 1
              ? '所有车型'
              : detail.orderVehiclesStr
          }}
        </div>
        <div v-if="detail.cityNames">
          适用城市(区域)：{{ detail.cityNames }}
        </div>
        <div v-if="detail.payType">
          支付限制：{{
            Number(detail.payType) === 1
              ? '所有线上支付'
              : '仅限个人余额支付或组合支付'
          }}
        </div>
        <div v-if="detail.timeType || detail.timePeriods">
          可用时段：{{
            Number(detail.timeType) === 1
              ? '全天'
              : parseTimePeriods(detail.timePeriods)
          }}
        </div>
        <div
          v-if="
            Number(detail.weekType) === 2 &&
              (Number(detail.purposeType) === 5 ||
                Number(detail.purposeType) === 4)
          "
        >
          可用日期：{{ detail.weekValue | filterAvailableDate }}
        </div>
        <div v-if="Number(detail.purposeType) === 4">
          此券不适用于搬运费、货物保障服务费
        </div>
        <div v-if="Number(detail.businessType) === 4">
          此券不适用于大车车型，不适用于搬运费
        </div>
        <div
          v-if="
            Number(detail.purposeType) === 4 &&
              Number(detail.movePackageType) === 2 &&
              detail.movePackageNames
          "
        >
          可用套餐：{{ detail.movePackageNames }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useCoupon } from '@/components/js/lalaPrize/lalaCoupon';
import { formatTime, isWxMiniProgram, isWeixinBrowser } from '@/utils';
import { mapActions, mapMutations } from 'vuex';
import { isXlApp } from '@/utils/judgeEnv';

const REAWRD_TYPE_STR_MAP = {
  4: 'coupon',
  2: 'cash',
  6: 'oil'
};
const CLIENT_TYPE_MAP = {
  0: '全部',
  1: '个人版-安卓',
  2: '个人版-IOS',
  3: '个人版-Web',
  4: '微信',
  5: '个人版-M站',
  6: '个人版-菜鸟M站',
  7: '个人版-菜鸟M站',
  8: '企业版-安卓',
  9: '企业版-IOS',
  10: '微信小程序',
  12: '百度小程序',
  13: '快应用',
  14: '支付宝小程序',
  100: '闲鱼/菜鸟'
};

const WEEK_MAP = {
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六',
  7: '周日'
};

// 折扣类型，1-立减券;2-折扣券
export const COUPON_DICOUNT_TYPE = {
  1: 'DISCOUNT_NO_CONDITION',
  2: 'DISCOUNT_BY_RATE',
  3: 'DISCOUNT_WITH_CONDITION'
};

export default {
  data() {
    return {
      isShowRule: false,
      detail: null
    };
  },
  props: {
    data: Object,
    isShowRuleBtn: {
      type: Boolean,
      default: false
    },
    isShowToUseButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    priceStr() {
      let num =
        this.data.discountType == 1
          ? this.data.discountAmount / 100
          : (this.data.discountRate / 10).toFixed(1);
      return num.toString();
    },
    integral() {
      return this.priceStr.split('.')[0];
    },
    decimal() {
      return this.priceStr.split('.')[1] || 0;
    },
    integralCash() {
      let num = this.data.amount / 100;
      return num;
    },
    couponType() {
      if (Number(this.data.discountType) === 1 && this.data.reachFen) {
        return COUPON_DICOUNT_TYPE[3];
      }
      return COUPON_DICOUNT_TYPE[this.data.discountType];
    }
  },
  filters: {
    timeFormat: function(v) {
      return v
        ? formatTime(
            'yyyy.MM.dd',
            new Date(typeof v === 'string' ? v.replace(/-/g, '/') : v)
          )
        : '';
    },
    tagText(data) {
      if (REAWRD_TYPE_STR_MAP[data.rewardType] === 'coupon') {
        return data.businessTypeStr;
      }
      if (REAWRD_TYPE_STR_MAP[data.rewardType] === 'cash') {
        return '现金';
      }
      if (REAWRD_TYPE_STR_MAP[data.rewardType] === 'oil') {
        return '权益卡';
      }
    },
    filterState(value) {
      switch (Number(value)) {
        case 12:
          return '领取失败';
        case 13:
          return '已使用';
        case 14:
          return '已过期';
        default:
          return '去使用';
      }
    },
    filterPurpose(value) {
      switch (Number(value)) {
        case 1:
          return '下单减免';
        case 2:
          return '充值抵扣';
        case 3:
          return '会员兑换';
        case 4:
          return '无忧搬家';
        case 5:
          return '便捷搬家';
      }
    },
    filterAvailableDate(value) {
      if (!value) {
        return '';
      }
      let dateArr = value.split(',');
      let newDateArr = dateArr.map(item => WEEK_MAP[Number(item)]);
      return newDateArr.join('、');
    },
    filterClient(value) {
      if (!value) {
        return '';
      }
      const clientTypeArr = value.split(',');
      const resArr = clientTypeArr.map(val => CLIENT_TYPE_MAP[Number(val)]);
      return resArr.join(',');
    }
  },
  methods: {
    ...mapMutations('app', ['scroll']),
    ...mapActions('app', ['getCounponDetail']),
    // 跳转到邀请人主页我的奖励
    toHome() {
      this.scroll('true');
      this.$router.push({
        path: '/',
        query: this.$route.query
      });
    },
    getBusiness(value) {
      switch (Number(value)) {
        case 1:
          return '通用';
        case 2:
          return '搬家';
        case 3:
          return '大车';
        case 4:
          return '小车';
        case 5:
          return '零担物流';
        case 6:
          return '司机会员';
        case 7:
          return '企业货运';
        case 8:
          return '小拉';
        default:
          return '';
      }
    },
    useTicket({ businessType }) {
      this.trackLog('使用', true, {
        coupon_business: this.getBusiness(businessType),
        actEventType: 'invited_reward_click'
      });
      console.log(isWxMiniProgram(), isXlApp(), businessType);
      if (!isWeixinBrowser() && !isWxMiniProgram() && !isXlApp()) {
        this.$hll.toast('请在微信环境打开');
      }
      useCoupon(businessType);
    },
    async handleClickRule() {
      this.isShowRule = !this.isShowRule;
      if (this.isShowRule && !this.detail) {
        const result = await this.getCounponDetail(this.data.rewardCode);
        if (result) {
          this.detail = result;
        }
      }
    },
    handleClickWithdraw() {
      this.$router.push({
        path: '/my_awards',
        query: this.$route.query
      });
    },
    isRewardType(data, typeStr) {
      return REAWRD_TYPE_STR_MAP[data.rewardType] === typeStr;
    },
    couponDescText(data) {
      const type = this.couponType;
      switch (type) {
        case 'DISCOUNT_NO_CONDITION':
          return '下单立减';
        case 'DISCOUNT_BY_RATE':
          return `最高减${data.discountAmount / 100}元`;
        case 'DISCOUNT_WITH_CONDITION':
          return `满${data.reachFen / 100}立减`;
        default:
          return '';
      }
    },
    parseTimePeriods(timeArray) {
      const resArr = timeArray.map(obj => `${obj.startTime}~${obj.endTime}`);
      return resArr.join(',');
    }
  }
};
</script>

<style lang="less" scoped>
.listItem {
  width: 702px;
  margin-bottom: 16px;
  box-sizing: border-box;
  &:last-child {
    margin-bottom: 0px;
  }

  .rulePanel {
    opacity: 0.85;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.09);
    padding: 24px 20px;

    > div::before {
      content: '・';
    }
  }
}
.coupon_item {
  display: flex;
  opacity: 1;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.09);
  padding: 26px 32px;

  .left {
    min-width: 160px;
    overflow: hidden;

    .couponHead {
      display: flex;
      flex-direction: column;
      align-items: center;
      line-height: 1.1;
      .value {
        color: #ff2727;
        font-family: 'Alibaba-Bold';
        margin-bottom: 22px;

        .integerPart {
          font-size: 80px;
        }

        .floatPart {
          font-size: 36px;
        }

        .unit {
          font-size: 30px;
        }
      }
      .condition {
        font-size: 24px;
        color: #595959;
      }
    }

    .cashHead {
      overflow: hidden;
      width: 138px;
      height: 124px;
      text-align: center;
      font-size: 30px;
      color: #ed2000;
      background: center / cover no-repeat
        url('../../assets/images/icon_cash_head.png');

      .value {
        margin-top: 20px;
        font-family: 'Alibaba-Bold';

        .integerPart {
          font-size: 46px;
        }

        .floatPart {
          font-size: 27px;
        }

        .unit {
          font-size: 27px;
        }
      }
    }

    .oilHead {
      width: 146px;
      height: 146px;
      box-sizing: border-box;
      background: center / cover no-repeat
        url('../../assets/images/oil_coupon_bg.png');
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0;
      color: #fff;
    }
  }

  .right {
    display: flex;
    flex: 1;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    min-height: 128px;
    position: relative;
    > button {
      width: 120px;
      height: 48px;
      display: inline-block;
      background: #fff14c;
      position: absolute;
      top: 38px;
      padding: 0px;
      right: 24px;
      font-size: 24px;
      color: #ff6600;
      border-radius: 25px;
    }
    .right_content {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin-left: 25px;
      min-height: 128px;

      .name {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .type {
          border: 1px solid #e43d23;
          border-radius: 5px;
          color: #e43d23;
          font-size: 22px;
          padding: 2px 4px;
          margin-right: 10px;
        }
        .text {
          max-width: 400px;
          font-size: 30px;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          overflow-x: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: bolder;
        }
      }

      .time {
        font-size: 24px;
        font-weight: 400;
        color: #595959;
        line-height: 28px;
      }

      .detail {
        margin-top: 20px;
        font-size: 24px;
        color: #8c8c8c;

        .ruleArrow {
          display: inline-block;
          width: 18px;
          height: 18px;
          background: center / cover url('../../assets/images/arrow_down.png')
            no-repeat;
          &.reverse {
            transform: rotate(180deg);
          }
        }
      }
    }
    .right_btn {
      position: absolute;
      right: 0;
      align-self: flex-end;
      margin-right: 16px;
      background: linear-gradient(to top, #ff6611 0%, #ff7e00 99%);
      border-radius: 40px;
      font-size: 24px;
      color: #ffffff;
      text-align: center;
      padding: 8px 28px;
    }
  }
}
</style>
